/** @internal */
export class SessionDescription {
    public sdp!: string;
    public type!: string;


    public static Load(x: any): SessionDescription {
        const sd = new SessionDescription();
        sd.sdp = x.sdp;
        sd.type = x.type;

        return sd;
    }

    public static Create(SessionDescription: RTCSessionDescription): SessionDescription {
        return {
            type: SessionDescription.type.toLowerCase(),
            sdp: SessionDescription.sdp,
        } as SessionDescription;
    }

    public ToRTCSessionDescription(): RTCSessionDescription {
        return {
            sdp: this.sdp,
            type: this.type.toLowerCase(),
        } as RTCSessionDescription;
    }
}
